"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChallenge = useChallenge;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function useChallenge() {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    formatNumber,
    toDistance
  } = (0, _hooks.useUnits)();
  function getProgressValue(type, progressValue) {
    switch (type) {
      case 'traveledDistance':
        return toDistance(progressValue);
      case 'cyclingDays':
        return t('commons.day', {
          count: Math.round(progressValue * 10) / 10
        });
      case 'homeWorkJourneysCount':
      case 'journeysCount':
        return t('commons.journeys', {
          count: Math.round(progressValue * 10) / 10
        });
      default:
        return `${Math.round(progressValue * 10) / 10} pts`;
    }
  }
  function getProgressValueWithUnit(type, progressValue) {
    switch (type) {
      case 'traveledDistance':
        return t('commons.stats.distance', {
          count: Math.floor(progressValue / 1000),
          distance: toDistance(progressValue)
        });
      case 'cyclingDays':
        return t('commons.stats.active_days', {
          count: progressValue
        });
      case 'homeWorkJourneysCount':
      case 'journeysCount':
        return t('commons.stats.journeys', {
          count: progressValue,
          countFormatted: formatNumber(progressValue)
        });
      default:
        return `${Math.round(progressValue)} pts`;
    }
  }
  function getFormattedProgressValue(challenge, {
    highlight
  } = {}) {
    const {
      type,
      period,
      targetValue,
      progressValue
    } = challenge;
    if (period === 'future' && !targetValue) return '-';
    switch (type) {
      case 'traveledDistance':
        return period === 'future' ? t('commons.challenge_details.objective', {
          target: toDistance(targetValue)
        }) : highlight ? targetValue ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenge_details.objective_without_target'), "\xA0", /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, toDistance(progressValue)), "\xA0/\xA0", toDistance(targetValue)) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, toDistance(progressValue)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, toDistance(progressValue), targetValue ? ` / ${toDistance(targetValue)}` : '');
      case 'cyclingDays':
        return period === 'future' ? t('commons.challenge_details.objective', {
          target: t('commons.day', {
            count: targetValue
          })
        }) : highlight ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenge_details.objective_without_target'), "\xA0", /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, progressValue), "\xA0/\xA0", t('commons.day', {
          count: targetValue
        })) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, t('commons.day', {
          count: progressValue
        }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? `${progressValue} / ${t('commons.day', {
          count: targetValue
        })}` : t('commons.day', {
          count: progressValue
        }));
      case 'homeWorkJourneysCount':
      case 'journeysCount':
        return period === 'future' ? t('commons.challenge_details.objective', {
          target: t('commons.journeys', {
            count: targetValue
          })
        }) : highlight ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenge_details.objective_without_target'), "\xA0", /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, progressValue), "\xA0/\xA0", t('commons.journeys', {
          count: targetValue
        })) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, t('commons.journeys', {
          count: progressValue
        }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? `${progressValue} / ${t('commons.journeys', {
          count: targetValue
        })}` : t('commons.journeys', {
          count: progressValue
        }));
      case 'bttf':
        return period === 'future' ? targetValue ? t('commons.challenge_details.objective', {
          target: t('commons.stats.points', {
            count: targetValue
          })
        }) : t('commons.stats.points', {
          count: targetValue
        }) : highlight ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('commons.challenge_details.objective_without_target'), "\xA0", /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, progressValue), "\xA0/\xA0", t('commons.stats.points', {
          count: targetValue
        })) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
          color: "#048760",
          component: "span",
          fontSize: "inherit",
          fontWeight: 700
        }, t('commons.stats.points', {
          count: progressValue
        }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetValue ? `${progressValue} / ${t('commons.stats.points', {
          count: targetValue
        })}` : t('commons.stats.points', {
          count: progressValue
        }));
      default:
        return;
    }
  }
  return {
    getProgressValue,
    getProgressValueWithUnit,
    getFormattedProgressValue
  };
}